var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component, createRef } from "react";
import { motion } from "framer-motion";
import { X, Maximize2, Minimize2, Move, Square, Send, ChevronUp, ChevronDown, Sun, Moon, Mail, Phone, MessageSquare, Sparkles, Zap, ShieldCheck, RectangleVertical, RectangleHorizontal, Mic, MicOff } from "lucide-react";
import { MdFullscreen, MdFullscreenExit } from 'react-icons/md';
import { Rnd } from "react-rnd";
import { ConnectionState } from "livekit-client";
import { LiveKitRoom, VideoTrack, useVoiceAssistant, useConnectionState, RoomAudioRenderer, StartAudio, useLocalParticipant, useChat, useTrackTranscription, useRoomContext, useIsSpeaking, BarVisualizer } from "@livekit/components-react";
import { Track, RoomEvent } from 'livekit-client';
import Tooltip from './ui/Tooltip';
import { VideoAudioSwitch } from './ui/video-audio-switch';
import { env } from '../config/env';
import EdgeAvatarMode from './EdgeAvatarMode';
import { getAvatarConfig } from '../config/avatarConfig';
// Scrollbar styles are in theme.css
// If the agent has not begun its welcome message within this long, open the
// mic anyway rather than leaving the user unable to speak.
var GREETING_MIC_TIMEOUT_MS = 10000;
// Helper function for device detection
function getDeviceType() {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return isMobile ? 'mobile' : 'desktop';
}
// Inner component to use LiveKit hooks
var SimpleAvatarInner = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var isCircle = _a.isCircle, windowSize = _a.windowSize, isVoiceMode = _a.isVoiceMode, isInputExpanded = _a.isInputExpanded;
    var _d = useVoiceAssistant(), agent = _d.agent, videoTrack = _d.videoTrack, audioTrack = _d.audioTrack, agentState = _d.state;
    var isSessionActive = React.useMemo(function () {
        var s = String(agentState || '').toLowerCase();
        return s === 'sessionactive';
    }, [agentState]);
    var connectionState = useConnectionState();
    var localApi = useLocalParticipant();
    var room = useRoomContext();
    var _e = useChat(), sendChat = _e.send, chatMessages = _e.chatMessages;
    var _f = React.useState(true), chipsVisible = _f[0], setChipsVisible = _f[1];
    // Suggested quick-reply chips
    var suggestedChips = [
        "What's your story?",
        "Book a meeting",
        "Tell me more",
        "How can you help?",
    ];
    // Expose sendText method through ref
    React.useImperativeHandle(ref, function () { return ({
        sendText: function (text) {
            var trimmed = text.trim();
            if (trimmed) {
                console.log('Sending text to LiveKit chat:', trimmed);
                sendChat(trimmed);
                setChipsVisible(false);
            }
        }
    }); }, [sendChat]);
    // Debug: log incoming chat messages
    React.useEffect(function () {
        console.log('[AvatarWidget Overlay] chatMessages count:', chatMessages.length, chatMessages);
    }, [chatMessages]);
    // Track transcriptions: agent (remote audio) and local mic
    var agentTranscription = useTrackTranscription(audioTrack && audioTrack
        ? {
            publication: audioTrack.publication,
            source: (_b = audioTrack.source) !== null && _b !== void 0 ? _b : Track.Source.Microphone,
            participant: audioTrack.participant,
        }
        : undefined);
    var localUser = (_c = localApi === null || localApi === void 0 ? void 0 : localApi.localParticipant) !== null && _c !== void 0 ? _c : localApi;
    var localMicPub = React.useMemo(function () {
        var micFromApi = localApi === null || localApi === void 0 ? void 0 : localApi.microphoneTrack;
        if (micFromApi)
            return micFromApi;
        var lp = localUser;
        if (!lp || typeof lp.getTrackPublications !== 'function')
            return undefined;
        var pubs = Array.from(lp.getTrackPublications().values());
        return pubs.find(function (p) { return (p === null || p === void 0 ? void 0 : p.kind) === 'audio' || (p === null || p === void 0 ? void 0 : p.source) === Track.Source.Microphone; });
    }, [localApi, localUser]);
    var localMicTrackRef = React.useMemo(function () {
        return localMicPub && localUser
            ? {
                publication: localMicPub,
                source: Track.Source.Microphone,
                participant: localUser,
            }
            : undefined;
    }, [localMicPub, localUser]);
    var localTranscription = useTrackTranscription(localMicTrackRef);
    React.useEffect(function () {
        console.log('[AvatarWidget Overlay] agent segments:', agentTranscription.segments);
    }, [agentTranscription.segments]);
    React.useEffect(function () {
        console.log('[AvatarWidget Overlay] local segments:', localTranscription.segments);
    }, [localTranscription.segments]);
    // Handy when diagnosing a "mic is dead" report: __talkbotRoom.localParticipant
    // shows exactly what is published, and when.
    React.useEffect(function () {
        window.__talkbotRoom = room;
    }, [room]);
    // Debug: log agentState and isSessionActive
    React.useEffect(function () {
        console.log('[AvatarWidget Overlay] agentState:', agentState, 'isSessionActive:', isSessionActive);
    }, [agentState, isSessionActive]);
    // Hold the microphone until the welcome message is done: the agent goes
    // 'speaking' for the greeting, and the first time it leaves that state we
    // publish. Once open it stays open — later replies must not re-mute it.
    var greetingDoneRef = React.useRef(false);
    var _g = React.useState(false), micReady = _g[0], setMicReady = _g[1];
    // Tracks an explicit user mute so the greeting/safety-net auto-enable
    // effects below don't fight the user's own mic button.
    var userMutedRef = React.useRef(false);
    React.useEffect(function () {
        var _a, _b;
        var state = String(agentState || '').toLowerCase();
        if (state === 'speaking')
            greetingDoneRef.current = true;
        if (!greetingDoneRef.current || micReady)
            return;
        if (state === 'speaking' || state === 'connecting' || state === 'initializing')
            return;
        setMicReady(true);
        if (userMutedRef.current)
            return;
        (_b = (_a = room === null || room === void 0 ? void 0 : room.localParticipant) === null || _a === void 0 ? void 0 : _a.setMicrophoneEnabled(true)) === null || _b === void 0 ? void 0 : _b.catch(function (e) { return console.warn('[AvatarWidget] mic enable failed', e); });
    }, [agentState, micReady, room]);
    // Safety net: some agents never greet. Without this the mic would stay
    // shut for the whole session and the user could not speak at all.
    React.useEffect(function () {
        if (connectionState !== ConnectionState.Connected || micReady)
            return;
        var t = setTimeout(function () {
            var _a, _b;
            if (greetingDoneRef.current)
                return; // greeting in progress, let it finish
            setMicReady(true);
            if (userMutedRef.current)
                return;
            (_b = (_a = room === null || room === void 0 ? void 0 : room.localParticipant) === null || _a === void 0 ? void 0 : _a.setMicrophoneEnabled(true)) === null || _b === void 0 ? void 0 : _b.catch(function (e) { return console.warn('[AvatarWidget] mic enable failed', e); });
        }, GREETING_MIC_TIMEOUT_MS);
        return function () { return clearTimeout(t); };
        // `room` is stable; `localApi` is not — depending on it would restart
        // this timer on every render and it would never fire.
    }, [connectionState, micReady, room]);
    // Manual mic mute/unmute so the user can stop their audio from being sent.
    var isMicOn = !!(localApi === null || localApi === void 0 ? void 0 : localApi.isMicrophoneEnabled);
    var handleMicToggle = React.useCallback(function () {
        var _a, _b;
        var next = !isMicOn;
        userMutedRef.current = !next;
        (_b = (_a = room === null || room === void 0 ? void 0 : room.localParticipant) === null || _a === void 0 ? void 0 : _a.setMicrophoneEnabled(next)) === null || _b === void 0 ? void 0 : _b.catch(function (e) { return console.warn('[AvatarWidget] mic toggle failed', e); });
    }, [isMicOn, room]);
    // Voice-activity feedback: true only while the mic is on AND LiveKit is
    // actually detecting the user's voice, so "listening" and "speaking" read
    // as distinct states rather than both looking like "on".
    var isLocalSpeaking = useIsSpeaking(localUser);
    var micStatus = !isMicOn
        ? 'off'
        : isLocalSpeaking
            ? 'speaking'
            : 'listening';
    var micStatusLabel = micStatus === 'off' ? 'Mic off' : micStatus === 'speaking' ? 'Speaking…' : 'Listening';
    // Fallback: listen for LiveKit data packets with topic 'lk.transcription'
    var _h = React.useState([]), dataTranscripts = _h[0], setDataTranscripts = _h[1];
    React.useEffect(function () {
        if (!room)
            return;
        var handler = function (payload, participant, _kind, topic) {
            var _a;
            try {
                if (topic === 'lk.transcription') {
                    var text_1 = new TextDecoder().decode(payload);
                    // Try JSON parse first
                    try {
                        var obj = JSON.parse(text_1);
                        var line_1 = (obj === null || obj === void 0 ? void 0 : obj.text) || (obj === null || obj === void 0 ? void 0 : obj.message) || ((_a = obj === null || obj === void 0 ? void 0 : obj.segment) === null || _a === void 0 ? void 0 : _a.text) || text_1;
                        setDataTranscripts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ text: line_1, time: Date.now() }], false).slice(-10); });
                        console.log('[AvatarWidget Overlay] lk.transcription:', obj);
                    }
                    catch (_b) {
                        setDataTranscripts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ text: text_1, time: Date.now() }], false).slice(-10); });
                        console.log('[AvatarWidget Overlay] lk.transcription text:', text_1);
                    }
                }
                else if (topic) {
                    // Log other topics for visibility
                    console.log('[AvatarWidget Overlay] DataReceived topic:', topic);
                }
            }
            catch (e) {
                console.warn('DataReceived handler error:', e);
            }
        };
        room.on(RoomEvent.DataReceived, handler);
        return function () {
            room.off(RoomEvent.DataReceived, handler);
        };
    }, [room]);
    var transcriptItems = React.useMemo(function () {
        try {
            // Every source below carries a real wall-clock timestamp so messages
            // can be sorted chronologically across sources. Round-robin-by-array-
            // position previously stood in for this and would show the agent's
            // reply above the user's own question whenever both arrays advanced
            // in the same tick — messages must be ordered by actual time, not by
            // which array happened to grow first.
            var agentItems = agentTranscription.segments
                .filter(function (s) { var _a; return (_a = s === null || s === void 0 ? void 0 : s.text) === null || _a === void 0 ? void 0 : _a.trim(); })
                .map(function (s) { return ({ side: 'left', text: s.text, source: 'agent', time: Number(s.firstReceivedTime) || Number(s.lastReceivedTime) || 0 }); });
            var localItems = localTranscription.segments
                .filter(function (s) { var _a; return (_a = s === null || s === void 0 ? void 0 : s.text) === null || _a === void 0 ? void 0 : _a.trim(); })
                .map(function (s) { return ({ side: 'right', text: s.text, source: 'local', time: Number(s.firstReceivedTime) || Number(s.lastReceivedTime) || 0 }); });
            var localSid_1 = localUser === null || localUser === void 0 ? void 0 : localUser.sid;
            var chatItems = chatMessages
                .map(function (m) {
                var _a;
                var from = (m === null || m === void 0 ? void 0 : m.from) || {};
                var isSelf = !!((from.sid && localSid_1 && from.sid === localSid_1) ||
                    (from.identity && (localUser === null || localUser === void 0 ? void 0 : localUser.identity) && from.identity === localUser.identity) ||
                    (from.isLocal === true));
                var msg = (_a = m === null || m === void 0 ? void 0 : m.message) !== null && _a !== void 0 ? _a : '';
                return String(msg).trim()
                    ? { side: isSelf ? 'right' : 'left', text: msg, source: isSelf ? 'self-chat' : 'ai-chat', time: Number(m === null || m === void 0 ? void 0 : m.timestamp) || 0 }
                    : null;
            })
                .filter(function (item) { return item !== null; });
            var dataItems = dataTranscripts
                .filter(function (t) { return (t === null || t === void 0 ? void 0 : t.text) && String(t.text).trim(); })
                .map(function (t) { return ({ side: 'left', text: String(t.text), source: 'data', time: t.time }); });
            // Sort by real time (stable sort keeps same-timestamp items in
            // arrival order) instead of interleaving by array position.
            var merged = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], agentItems, true), localItems, true), chatItems, true), dataItems, true).sort(function (a, b) { return a.time - b.time; });
            return merged.slice(-10).map(function (item, index) { return (__assign(__assign({}, item), { index: index })); });
        }
        catch (_a) {
            return [];
        }
    }, [agentTranscription.segments, localTranscription.segments, chatMessages, localUser, dataTranscripts]);
    // Auto-scroll overlay to latest message after full completion
    var overlayRef = React.useRef(null);
    React.useEffect(function () {
        var el = overlayRef.current;
        if (!el)
            return;
        // Use requestAnimationFrame to ensure scroll happens after render
        requestAnimationFrame(function () {
            el.scrollTop = el.scrollHeight;
        });
    }, [transcriptItems]);
    // Audio animation component for voice mode
    var AudioAnimation = function () { return (React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 } }, [8, 14, 6, 12, 8].map(function (h, i) { return (React.createElement("div", { key: i, className: "talkbot-audio-bar", style: {
            height: h * 2,
            background: "var(--tb-primary)",
            animationDelay: "".concat(i * 150, "ms"),
            opacity: 0.85 + (i % 2) * 0.15,
        } })); }))); };
    var handleChipClick = function (text) {
        sendChat(text);
        setChipsVisible(false);
    };
    // Helper to linkify URLs in text
    // Helper to linkify both markdown-style [text](url) and plain URLs
    function linkify(text) {
        // First, replace markdown links [text](url)
        var mdLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g;
        var replaced = text.replace(mdLinkRegex, function (match, linkText, url) {
            return "<a href=\"".concat(url, "\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"color:#A78BFA;text-decoration:underline;\">").concat(linkText, "</a>");
        });
        // Then, replace plain URLs (not already inside an anchor)
        var urlRegex = /(?<![\">])(https?:\/\/(?:[\w-]+\.)+[\w-]+(?:\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?)/gi;
        replaced = replaced.replace(urlRegex, function (url) {
            return "<a href=\"".concat(url, "\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"color:#A78BFA;text-decoration:underline;\">").concat(url, "</a>");
        });
        return replaced;
    }
    return (React.createElement("div", { className: "talkbot-center", style: isCircle ? { borderRadius: '50%' } : undefined },
        React.createElement(RoomAudioRenderer, null),
        React.createElement(StartAudio, { label: "Start Audio" }),
        connectionState === ConnectionState.Connected && !(isInputExpanded && !isCircle) && (React.createElement("div", { style: {
                position: 'absolute',
                bottom: isCircle ? 10 : 46,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1002,
                display: 'flex',
                alignItems: 'center',
                gap: isCircle ? 0 : 8,
            } },
            !isCircle && isMicOn && (React.createElement(BarVisualizer, { trackRef: localMicTrackRef, barCount: 5, options: { minHeight: 15, maxHeight: 100 }, className: "talkbot-mic-wave" })),
            React.createElement(Tooltip, { content: isMicOn ? 'Mute microphone' : 'Unmute microphone' },
                React.createElement("button", { onClick: handleMicToggle, className: "talkbot-mic-btn talkbot-mic-btn--".concat(micStatus), "aria-label": isMicOn ? 'Mute microphone' : 'Unmute microphone', "aria-pressed": !isMicOn },
                    micStatus === 'speaking' && (React.createElement("span", { className: "talkbot-mic-ring talkbot-mic-ring--active", "aria-hidden": "true" })),
                    isMicOn ? React.createElement(Mic, { size: 16 }) : React.createElement(MicOff, { size: 16 }))),
            !isCircle && (React.createElement("span", { className: "talkbot-mic-status talkbot-mic-status--".concat(micStatus) }, micStatusLabel)))),
        React.createElement("div", { ref: overlayRef, style: {
                position: 'absolute',
                bottom: isInputExpanded ? 100 : (isCircle ? 55 : 86),
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
                width: '90%',
                pointerEvents: 'auto',
                height: '100px',
                overflowY: 'auto',
                left: '5%',
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(0,0,0,0.15) transparent',
                transition: 'bottom 0.3s ease',
            }, className: "talkbot-overlay-scroll" }, transcriptItems.map(function (item) { return (React.createElement("div", { key: item.index, style: {
                display: 'flex',
                justifyContent: item.side === 'left' ? 'flex-start' : 'flex-end',
                width: '100%',
            } },
            React.createElement("div", { className: "talkbot-bubble ".concat(item.side === 'left' ? 'talkbot-bubble--bot' : 'talkbot-bubble--user'), dangerouslySetInnerHTML: { __html: linkify(item.text) } }))); })),
        videoTrack && !isVoiceMode ? (React.createElement("div", { style: __assign({ width: '100%', height: '100%', overflow: 'hidden', position: 'relative' }, (isCircle ? { borderRadius: '50%' } : {})) },
            React.createElement(VideoTrack, { trackRef: videoTrack, style: __assign({ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', transition: 'all 0.3s ease' }, (isCircle ? { borderRadius: '50%' } : {})) }))) : (React.createElement("div", { style: { textAlign: 'center', color: 'var(--tb-text)' } }, connectionState === ConnectionState.Connected ? (React.createElement(React.Fragment, null, isVoiceMode ? (React.createElement(React.Fragment, null,
            React.createElement(AudioAnimation, null),
            React.createElement("p", { style: { fontSize: 13, marginTop: 16 } }, "Voice Assistant Active"),
            React.createElement("p", { style: { fontSize: 11, marginTop: 8, opacity: 0.7 } },
                "State: ",
                agentState),
            chipsVisible && (React.createElement("div", { className: "talkbot-chips", style: { marginTop: 18, maxWidth: 280 } }, suggestedChips.map(function (chip) { return (React.createElement("button", { key: chip, className: "talkbot-chip", onClick: function () { return handleChipClick(chip); } }, chip)); }))))) : (React.createElement(React.Fragment, null,
            React.createElement("p", { style: { fontSize: 13 } }, "Waiting for Avatar..."),
            React.createElement("p", { style: { fontSize: 11, marginTop: 8, opacity: 0.7 } },
                "State: ",
                agentState),
            chipsVisible && (React.createElement("div", { className: "talkbot-chips", style: { marginTop: 18, maxWidth: 280 } }, suggestedChips.map(function (chip) { return (React.createElement("button", { key: chip, className: "talkbot-chip", onClick: function () { return handleChipClick(chip); } }, chip)); }))))))) : connectionState === ConnectionState.Connecting ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "talkbot-spinner", style: { margin: '0 auto 16px' } }),
            React.createElement("p", { style: { fontSize: 13 } }, "Connecting..."))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { fontSize: 36, marginBottom: 12 } }, "\u274C"),
            React.createElement("p", { style: { fontSize: 13 } }, "Connection Failed")))))));
});
var getDefaultWindowSize = function () {
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    if (getDeviceType() === 'mobile') {
        // Mobile: More aggressive responsive sizing
        return {
            width: Math.min(vw * 0.9, 340),
            height: Math.min(vh * 0.78, 540)
        };
    }
    else {
        // Desktop: Responsive but with reasonable limits
        return {
            width: Math.min(vw * 0.3, 400),
            height: Math.min(vh * 0.78, 560)
        };
    }
};
var SimpleAvatarWidget = /** @class */ (function (_super) {
    __extends(SimpleAvatarWidget, _super);
    function SimpleAvatarWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.startPos = { x: 0, y: 0 };
        _this.startSize = { width: 400, height: 500 };
        _this.handleWindowResize = function () {
            var isFullScreen = _this.state.isFullScreen;
            if (isFullScreen) {
                _this.setState({
                    windowSize: {
                        width: window.innerWidth,
                        height: window.innerHeight
                    }
                });
            }
            else {
                _this.adjustPositionToBounds();
            }
        };
        // Handle orientation change (mainly for mobile)
        _this.handleOrientationChange = function () {
            setTimeout(function () {
                _this.handleWindowResize();
                _this.forceUpdate();
            }, 100);
        };
        _this.adjustPositionToBounds = function () {
            var _a = _this.state, dragPosition = _a.dragPosition, windowSize = _a.windowSize;
            var vw = window.innerWidth;
            var vh = window.innerHeight;
            var newX = dragPosition.x;
            var newY = dragPosition.y;
            // Ensure widget stays within horizontal bounds
            if (newX + windowSize.width > vw) {
                newX = vw - windowSize.width - 10;
            }
            if (newX < 0) {
                newX = 10;
            }
            // Ensure widget stays within vertical bounds
            if (newY + windowSize.height > vh) {
                newY = vh - windowSize.height - 10;
            }
            if (newY < 0) {
                newY = 10;
            }
            // Update position if it changed
            if (newX !== dragPosition.x || newY !== dragPosition.y) {
                _this.setState({
                    dragPosition: { x: newX, y: newY }
                });
            }
        };
        // Generate connection details using your API
        _this.generateConnectionDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var apiBaseUrl, _a, userEmail, userContact, videoMode, domain, mode, avatarCfg, params, response, data, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        apiBaseUrl = env.livekitTokenUrl;
                        _a = this.state, userEmail = _a.userEmail, userContact = _a.userContact, videoMode = _a.videoMode;
                        domain = this.props.domain || window.location.hostname;
                        mode = videoMode ? 'avatar' : 'defaultMode';
                        this.setState({ isLoading: true, error: null });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        avatarCfg = getAvatarConfig(this.props.avatarConfig);
                        params = new URLSearchParams({
                            domain: domain,
                            mode: mode,
                            email: userEmail,
                            contact: userContact,
                            // The agent reads these from the token metadata. 'remote' is what
                            // makes it start the cloud avatar and publish a video track; any
                            // browser-rendered mode must say 'local' so it does not.
                            render: videoMode && avatarCfg.render === 'livekit' ? 'remote' : 'local',
                            avatarId: avatarCfg.avatar
                        });
                        return [4 /*yield*/, fetch("".concat(apiBaseUrl, "/api/token?").concat(params.toString()))];
                    case 2:
                        response = _b.sent();
                        if (!response.ok) {
                            throw new Error("Token fetch failed: ".concat(response.statusText));
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        data = _b.sent();
                        // Validate that we received all required fields
                        if (!data.serverUrl || !data.roomName || !data.participantToken || !data.participantName) {
                            throw new Error('Incomplete connection details received from server');
                        }
                        this.setState({
                            connectionDetails: data,
                            isLoading: false,
                            showForm: false
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        console.error('Failed to generate connection details:', error_1);
                        this.setState({
                            error: "Connection failed: ".concat(error_1 instanceof Error ? error_1.message : 'Unknown error'),
                            isLoading: false
                        });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // Form validation
        _this.validateForm = function () {
            var _a = _this.state, userEmail = _a.userEmail, userContact = _a.userContact;
            var errors = {};
            // Email validation
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!userEmail.trim()) {
                errors.email = 'Email is required';
            }
            else if (!emailRegex.test(userEmail)) {
                errors.email = 'Please enter a valid email address';
            }
            // Contact validation
            var contactRegex = /^[\+]?[1-9][\d]{0,15}$/;
            if (!userContact.trim()) {
                errors.contact = 'Contact number is required';
            }
            else if (!contactRegex.test(userContact.replace(/[-\s\(\)]/g, ''))) {
                errors.contact = 'Please enter a valid contact number';
            }
            _this.setState({ formErrors: errors });
            return Object.keys(errors).length === 0;
        };
        // Handle form submission
        _this.handleFormSubmit = function (e) {
            e.preventDefault();
            if (_this.validateForm()) {
                if (_this.state.videoMode && getAvatarConfig(_this.props.avatarConfig).render !== 'livekit') {
                    // Browser-rendered avatar: EdgeAvatarMode fetches its own token and
                    // connects to LiveKit itself (edge-SDK canvas or GPU gateway).
                    _this.setState({ showForm: false, error: null });
                }
                else {
                    // Voice mode, and server-rendered avatar mode: plugin token API +
                    // LiveKitRoom flow (the avatar arrives as the agent's video track).
                    _this.generateConnectionDetails();
                }
            }
        };
        // Handle input changes
        _this.handleInputChange = function (field, value) {
            var _a, _b;
            _this.setState((_a = {},
                _a[field] = value,
                _a.formErrors = __assign(__assign({}, _this.state.formErrors), (_b = {}, _b[field.replace('user', '').toLowerCase()] = undefined, _b)),
                _a));
        };
        // Handle mouse events for resizing
        _this.handleMouseMove = function (e) {
            if (!_this.state.isResizing)
                return;
            var deltaX = e.clientX - _this.startPos.x;
            var deltaY = e.clientY - _this.startPos.y;
            var newWidth = Math.max(300, _this.startSize.width + deltaX);
            var newHeight = Math.max(400, _this.startSize.height + deltaY);
            _this.setState({ windowSize: { width: newWidth, height: newHeight } });
        };
        _this.handleMouseUp = function () {
            if (_this.state.isResizing) {
                _this.setState({ isResizing: false });
                document.body.style.cursor = 'default';
            }
        };
        // Compute the fullscreen panel position + size for a given orientation.
        // Portrait  = a tall side panel anchored to the widget's side, ~1/4 of the
        //             viewport width, full height (on mobile it fills the screen).
        // Landscape = a large centred 16:9 panel.
        _this.getFullScreenLayout = function (orientation) {
            var vw = window.innerWidth;
            var vh = window.innerHeight;
            var isMobile = getDeviceType() === 'mobile';
            if (orientation === 'portrait') {
                if (isMobile) {
                    return { width: vw, height: vh, x: 0, y: 0 };
                }
                // ~1/4 of the viewport, clamped to a usable range, anchored to the side.
                var width_1 = Math.min(Math.max(Math.round(vw / 4), 340), 560);
                var x = _this.props.side === 'left' ? 0 : vw - width_1;
                return { width: width_1, height: vh, x: x, y: 0 };
            }
            // Landscape: large centred 16:9 window.
            var height = Math.min(Math.round(vh * 0.86), 680);
            var width = Math.min(Math.round(vw * 0.92), Math.round((height * 16) / 9));
            return {
                width: width,
                height: height,
                x: Math.max(0, Math.round((vw - width) / 2)),
                y: Math.max(0, Math.round((vh - height) / 2)),
            };
        };
        // Toggle the fullscreen panel between portrait and landscape (only while
        // in fullscreen). Re-positions the panel after changing.
        _this.toggleFullScreenOrientation = function () {
            _this.setState(function (prevState) {
                if (!prevState.isFullScreen)
                    return null;
                var next = prevState.fullScreenOrientation === 'portrait' ? 'landscape' : 'portrait';
                var l = _this.getFullScreenLayout(next);
                return __assign(__assign({}, prevState), { fullScreenOrientation: next, windowSize: { width: l.width, height: l.height }, dragPosition: { x: l.x, y: l.y } });
            }, function () {
                setTimeout(function () { return window.dispatchEvent(new Event('resize')); }, 150);
            });
        };
        // Add fullscreen functionality for the widget itself
        _this.handleToggleFullScreen = function () {
            _this.setState(function (prevState) {
                var newIsFullScreen = !prevState.isFullScreen;
                var vw = window.innerWidth;
                var vh = window.innerHeight;
                if (newIsFullScreen) {
                    // Entering fullscreen — panel positioned for the chosen orientation.
                    var l = _this.getFullScreenLayout(prevState.fullScreenOrientation);
                    return __assign(__assign({}, prevState), { isFullScreen: true, shape: 'box', dragPosition: { x: l.x, y: l.y }, windowSize: { width: l.width, height: l.height } });
                }
                else {
                    // Exiting fullscreen - restore to default size and position
                    var defaultSize = getDefaultWindowSize();
                    var isMobile = getDeviceType() === 'mobile';
                    var margin = isMobile ? Math.min(vw * 0.03, 15) : Math.min(vw * 0.02, 20);
                    var newX = _this.props.side === 'right' ? vw - defaultSize.width - margin : margin;
                    var newY = vh - defaultSize.height - (isMobile ? Math.min(vh * 0.1, 80) : Math.min(vh * 0.12, 90));
                    return __assign(__assign({}, prevState), { isFullScreen: false, dragPosition: { x: newX, y: newY }, windowSize: defaultSize });
                }
            }, function () {
                // Force a layout recalculation after fullscreen toggle
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 150);
            });
        };
        // Toggle between video mode (avatar) and voice mode (defaultMode)
        _this.toggleVideoMode = function () {
            _this.setState(function (prevState) { return ({
                videoMode: !prevState.videoMode
            }); });
        };
        // Send message to LiveKit (same pattern as ChatbotWindow)
        _this.sendMessage = function () {
            if (_this.state.message.trim() === '')
                return;
            // Use sendText method like ChatbotWindow
            if (_this.liveKitRef.current && _this.liveKitRef.current.sendText) {
                _this.liveKitRef.current.sendText(_this.state.message);
            }
            else {
                console.warn('LiveKit ref not available or sendText method not found');
            }
            // Clear the message input
            _this.setState({ message: '' });
        };
        // Handle key press for message input
        _this.handleKeyPress = function (e) {
            if (e.key === 'Enter') {
                _this.sendMessage();
            }
        };
        // Toggle input area expansion
        _this.toggleInputExpand = function () {
            _this.setState(function (prevState) { return ({
                isInputExpanded: !prevState.isInputExpanded
            }); });
        };
        var defaultSize = getDefaultWindowSize();
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var isMobile = getDeviceType() === 'mobile';
        // Responsive margins
        var margin = isMobile ? Math.min(vw * 0.03, 15) : Math.min(vw * 0.02, 20);
        // Responsive positioning
        var initialX = props.side === 'right'
            ? vw - defaultSize.width - margin
            : margin;
        var initialY = vh - defaultSize.height - (isMobile ? Math.min(vh * 0.1, 80) : Math.min(vh * 0.12, 90));
        _this.state = {
            windowSize: defaultSize,
            isResizing: false,
            shape: 'box',
            isFullScreen: false,
            fullScreenOrientation: 'portrait',
            dragPosition: { x: initialX, y: initialY },
            // LiveKit state
            connectionDetails: null,
            isLoading: false,
            error: null,
            avatarConnected: false,
            // User form state
            showForm: true,
            userEmail: '',
            userContact: '',
            formErrors: {},
            // Video/Voice mode state
            videoMode: true, // Default to avatar mode
            // Message input state
            message: '',
            isInputExpanded: false,
        };
        _this.windowRef = createRef();
        _this.liveKitRef = createRef();
        // Bind handlers
        _this.toggleShape = _this.toggleShape.bind(_this);
        _this.handleMaximize = _this.handleMaximize.bind(_this);
        _this.handleMinimize = _this.handleMinimize.bind(_this);
        _this.handleResizeStart = _this.handleResizeStart.bind(_this);
        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        _this.handleMouseUp = _this.handleMouseUp.bind(_this);
        _this.toggleSizeOption = _this.toggleSizeOption.bind(_this);
        _this.handleToggleFullScreen = _this.handleToggleFullScreen.bind(_this);
        _this.toggleVideoMode = _this.toggleVideoMode.bind(_this);
        _this.sendMessage = _this.sendMessage.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.toggleInputExpand = _this.toggleInputExpand.bind(_this);
        return _this;
    }
    SimpleAvatarWidget.prototype.componentDidMount = function () {
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
        window.addEventListener('resize', this.handleWindowResize);
        window.addEventListener('orientationchange', this.handleOrientationChange);
    };
    SimpleAvatarWidget.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.windowSize.width !== this.state.windowSize.width ||
            prevState.windowSize.height !== this.state.windowSize.height ||
            prevState.shape !== this.state.shape) {
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        }
    };
    SimpleAvatarWidget.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        window.removeEventListener('resize', this.handleWindowResize);
        window.removeEventListener('orientationchange', this.handleOrientationChange);
    };
    SimpleAvatarWidget.prototype.handleResizeStart = function (e) {
        e.preventDefault();
        this.setState({ isResizing: true });
        this.startPos = { x: e.clientX, y: e.clientY };
        this.startSize = __assign({}, this.state.windowSize);
        document.body.style.cursor = 'nwse-resize';
    };
    SimpleAvatarWidget.prototype.toggleShape = function () {
        this.setState(function (prevState) { return ({
            shape: prevState.shape === 'box' ? 'circle' : 'box'
        }); }, function () {
            // Force a layout recalculation after shape change
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 150);
        });
    };
    SimpleAvatarWidget.prototype.handleMaximize = function () {
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var isMobile = getDeviceType() === 'mobile';
        var maxSize = {
            width: isMobile
                ? Math.min(vw * 0.95, 420)
                : Math.min(vw * 0.7, 800),
            height: isMobile
                ? Math.min(vh * 0.85, 600)
                : Math.min(vh * 0.8, 700)
        };
        this.setState({ windowSize: maxSize }, function () {
            // Force a layout recalculation after state update
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 150);
        });
    };
    SimpleAvatarWidget.prototype.handleMinimize = function () {
        this.setState({ windowSize: getDefaultWindowSize() }, function () {
            // Force a layout recalculation after state update
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 150);
        });
    };
    // Toggle size between small, medium, large like ChatbotWidget
    SimpleAvatarWidget.prototype.toggleSizeOption = function () {
        var windowSize = this.state.windowSize;
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var isMobile = getDeviceType() === 'mobile';
        // Define responsive sizes based on viewport
        var sizes = isMobile
            ? [
                { width: Math.min(vw * 0.7, 280), height: Math.min(vh * 0.5, 360) }, // Small
                { width: Math.min(vw * 0.85, 350), height: Math.min(vh * 0.65, 450) }, // Medium  
                { width: Math.min(vw * 0.95, 420), height: Math.min(vh * 0.8, 550) }, // Large
            ]
            : [
                { width: Math.min(vw * 0.25, 300), height: Math.min(vh * 0.5, 400) }, // Small
                { width: Math.min(vw * 0.4, 500), height: Math.min(vh * 0.7, 600) }, // Medium
                { width: Math.min(vw * 0.6, 700), height: Math.min(vh * 0.85, 800) }, // Large
            ];
        // Find current size in the array
        var currentIndex = sizes.findIndex(function (size) {
            var widthDiff = Math.abs(windowSize.width - size.width);
            var heightDiff = Math.abs(windowSize.height - size.height);
            return widthDiff < (isMobile ? 30 : 50) && heightDiff < (isMobile ? 40 : 60);
        });
        var nextIndex = (currentIndex + 1) % sizes.length;
        this.setState({ windowSize: sizes[nextIndex] }, function () {
            // Force a layout recalculation after state update
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 150);
        });
    };
    SimpleAvatarWidget.prototype.getSizeIcon = function () {
        var windowSize = this.state.windowSize;
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var isMobile = getDeviceType() === 'mobile';
        if (isMobile) {
            // Mobile: determine icon based on viewport percentage
            var widthPercent = windowSize.width / vw;
            if (widthPercent <= 0.75) {
                return React.createElement(Minimize2, { size: 14 }); // Small
            }
            else if (widthPercent <= 0.9) {
                return React.createElement(Maximize2, { size: 16 }); // Medium
            }
            else {
                return React.createElement(Maximize2, { size: 18 }); // Large
            }
        }
        else {
            // Desktop: determine icon based on viewport percentage
            var widthPercent = windowSize.width / vw;
            if (widthPercent <= 0.3) {
                return React.createElement(Minimize2, { size: 16 }); // Small
            }
            else if (widthPercent <= 0.5) {
                return React.createElement(Maximize2, { size: 16 }); // Medium
            }
            else {
                return React.createElement(Maximize2, { size: 18 }); // Large
            }
        }
    };
    SimpleAvatarWidget.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, side = _b.side, header = _b.header, onClose = _b.onClose, verticalPosition = _b.verticalPosition;
        var _c = this.state, windowSize = _c.windowSize, shape = _c.shape, isFullScreen = _c.isFullScreen, connectionDetails = _c.connectionDetails, isLoading = _c.isLoading, error = _c.error, videoMode = _c.videoMode, avatarConnected = _c.avatarConnected;
        var isOnline = avatarConnected || !!connectionDetails;
        var fixedPosition = (_a = {
                bottom: 90,
                top: 0
            },
            _a[side] = 20,
            _a);
        // In fullscreen we pin the panel with CSS (overrides react-rnd's inline
        // transform/size) so it sits exactly where intended instead of overflowing.
        var fsClass = isFullScreen
            ? "talkbot-widget--fs talkbot-widget--fs-".concat(this.state.fullScreenOrientation) +
                (this.state.fullScreenOrientation === 'portrait'
                    ? " talkbot-widget--fs-".concat(side === 'left' ? 'left' : 'right')
                    : '')
            : '';
        return (React.createElement(React.Fragment, null,
            isFullScreen && (React.createElement("div", { className: "talkbot-fs-backdrop", "aria-hidden": "true", onClick: this.handleToggleFullScreen })),
            React.createElement(Rnd, { ref: this.windowRef, className: "talkbot-widget-frame ".concat(fsClass), style: __assign({ position: 'fixed', zIndex: isFullScreen ? 9999 : 50, transition: isFullScreen ? 'none' : 'all 0.3s', overflow: 'hidden', borderRadius: shape === 'circle' ? '50%' : 'var(--tb-radius)', background: 'var(--tb-bg)', display: 'flex', flexDirection: 'column' }, (shape === 'circle' ? { aspectRatio: '1' } : {})), size: {
                    width: windowSize.width,
                    height: shape === 'circle' ? windowSize.width : windowSize.height
                }, onDragStop: function (e, d) {
                    _this.setState({
                        dragPosition: { x: d.x, y: d.y },
                    });
                }, onResizeStop: function (e, direction, ref, delta, position) {
                    _this.setState({
                        windowSize: {
                            width: ref.offsetWidth,
                            height: ref.offsetHeight,
                        },
                        dragPosition: {
                            x: position.x,
                            y: position.y,
                        },
                    });
                }, default: {
                    x: fixedPosition[side],
                    y: fixedPosition[verticalPosition],
                    width: windowSize.width,
                    height: shape === 'circle' ? windowSize.width : windowSize.height,
                }, minWidth: isFullScreen ? 200 : (shape !== "circle" ? Math.min(window.innerWidth * 0.2, 300) : Math.min(window.innerWidth * 0.15, 120)), minHeight: isFullScreen ? 200 : (shape !== "circle" ? Math.min(window.innerHeight * 0.3, 400) : Math.min(window.innerHeight * 0.15, 120)), position: { x: this.state.dragPosition.x, y: this.state.dragPosition.y }, bounds: "window", disableDragging: isFullScreen, enableResizing: !isFullScreen, dragHandleClassName: "drag-handle" },
                shape === 'box' && (React.createElement("div", { className: "talkbot-header" },
                    React.createElement("div", { className: "talkbot-header-left" },
                        React.createElement("div", { className: "drag-handle talkbot-header-btn", style: { padding: 6, cursor: 'move' } },
                            React.createElement(Move, { size: getDeviceType() === 'mobile' ? 14 : 16 })),
                        (header === null || header === void 0 ? void 0 : header.logoUrl) ? (React.createElement("img", { src: header.logoUrl, alt: "logo", className: "talkbot-header-logo" })) : (React.createElement("div", { className: "talkbot-header-logo-fallback" }, "AI")),
                        React.createElement("div", { className: "talkbot-header-info" },
                            React.createElement("div", { className: "talkbot-header-title" }, (header === null || header === void 0 ? void 0 : header.title) || 'Talkbot'),
                            React.createElement("div", { className: "talkbot-header-subtitle" },
                                React.createElement("span", { className: "talkbot-status-dot ".concat(isOnline ? 'talkbot-status-dot--online' : isLoading ? 'talkbot-status-dot--loading' : 'talkbot-status-dot--offline') }),
                                isOnline ? 'Online' :
                                    isLoading ? 'Connecting...' :
                                        this.state.showForm ? 'Ready to connect' : 'Connecting...'))),
                    React.createElement("div", { className: "talkbot-header-actions" },
                        isFullScreen && (React.createElement(Tooltip, { content: this.state.fullScreenOrientation === 'portrait' ? 'Switch to landscape' : 'Switch to portrait' },
                            React.createElement("button", { onClick: this.toggleFullScreenOrientation, className: "talkbot-header-btn", style: { padding: getDeviceType() === 'mobile' ? 10 : 8 } }, this.state.fullScreenOrientation === 'portrait'
                                ? React.createElement(RectangleHorizontal, { size: getDeviceType() === 'mobile' ? 18 : 16 })
                                : React.createElement(RectangleVertical, { size: getDeviceType() === 'mobile' ? 18 : 16 })))),
                        React.createElement(Tooltip, { content: isFullScreen ? "Exit Fullscreen" : "Fullscreen" },
                            React.createElement("button", { onClick: this.handleToggleFullScreen, className: "talkbot-header-btn", style: { padding: getDeviceType() === 'mobile' ? 10 : 8 } }, isFullScreen ?
                                React.createElement(MdFullscreenExit, { size: getDeviceType() === 'mobile' ? 20 : 18 }) :
                                React.createElement(MdFullscreen, { size: getDeviceType() === 'mobile' ? 20 : 18 }))),
                        React.createElement(Tooltip, { content: this.props.themeMode === 'dark' ? 'Light Mode' : 'Dark Mode' },
                            React.createElement("button", { onClick: this.props.onToggleTheme, className: "talkbot-header-btn", style: { padding: getDeviceType() === 'mobile' ? 10 : 8 } }, this.props.themeMode === 'dark'
                                ? React.createElement(Sun, { size: getDeviceType() === 'mobile' ? 18 : 16 })
                                : React.createElement(Moon, { size: getDeviceType() === 'mobile' ? 18 : 16 }))),
                        React.createElement(Tooltip, { content: "Close" },
                            React.createElement("button", { onClick: onClose, className: "talkbot-header-btn", style: { padding: getDeviceType() === 'mobile' ? 10 : 8 } },
                                React.createElement(X, { size: getDeviceType() === 'mobile' ? 18 : 16 })))))),
                React.createElement("div", { className: "talkbot-content", style: {
                        height: shape === 'circle'
                            ? '100%'
                            : undefined,
                        flex: shape === 'circle' ? undefined : 1,
                        minHeight: 0,
                    } },
                    error && (React.createElement("div", { style: { padding: '12px 16px', background: 'rgba(153, 27, 27, 0.15)', borderBottom: '1px solid rgba(248,113,113,0.2)', flexShrink: 0 } },
                        React.createElement("div", { style: { color: '#F87171', fontSize: 13 } },
                            React.createElement("p", { style: { fontWeight: 600, margin: 0 } }, "Connection Error"),
                            React.createElement("p", { style: { fontSize: 11, marginTop: 4, opacity: 0.75, margin: '4px 0 0' } }, error),
                            React.createElement("button", { onClick: function () { return _this.setState({ showForm: true, error: null }); }, style: { marginTop: 8, padding: '5px 14px', background: 'var(--tb-primary)', color: '#fff', fontSize: 12, borderRadius: 'var(--tb-radius-sm)', border: 'none', cursor: 'pointer' } }, "Try Again")))),
                    React.createElement("div", { className: "talkbot-content-inner", style: shape === 'circle' ? { borderRadius: '50%', overflow: 'hidden' } : undefined }, this.state.showForm ? (
                    // User Information Form
                    React.createElement("div", { className: "talkbot-form-bg", style: shape === 'circle' ? { borderRadius: '50%' } : undefined },
                        React.createElement("div", { className: "talkbot-form-wrapper" },
                            React.createElement("div", { className: "talkbot-form-card" },
                                React.createElement("span", { className: "talkbot-form-glow", "aria-hidden": "true" }),
                                React.createElement("div", { className: "talkbot-form-head" },
                                    React.createElement("h2", { className: "talkbot-form-title" },
                                        "Welcome",
                                        React.createElement(Sparkles, { size: 18, className: "talkbot-form-title-spark" })),
                                    React.createElement("p", { className: "talkbot-form-subtitle" }, "Please enter your details to get started")),
                                React.createElement("form", { onSubmit: this.handleFormSubmit, className: "talkbot-form" },
                                    React.createElement("div", { className: "talkbot-form-group" },
                                        React.createElement("label", { className: "talkbot-form-label" },
                                            "Email Address ",
                                            React.createElement("span", { className: "talkbot-form-req" }, "*")),
                                        React.createElement("div", { className: "talkbot-form-field" },
                                            React.createElement("span", { className: "talkbot-form-field-icon" },
                                                React.createElement(Mail, { size: 18 })),
                                            React.createElement("input", { type: "email", inputMode: "email", autoComplete: "email", value: this.state.userEmail, onChange: function (e) { return _this.handleInputChange('userEmail', e.target.value); }, className: "talkbot-form-input", placeholder: "your.email@example.com", disabled: isLoading })),
                                        this.state.formErrors.email && (React.createElement("p", { className: "talkbot-form-error" }, this.state.formErrors.email))),
                                    React.createElement("div", { className: "talkbot-form-group" },
                                        React.createElement("label", { className: "talkbot-form-label" },
                                            "Contact Number ",
                                            React.createElement("span", { className: "talkbot-form-req" }, "*")),
                                        React.createElement("div", { className: "talkbot-form-field" },
                                            React.createElement("span", { className: "talkbot-form-field-icon" },
                                                React.createElement(Phone, { size: 18 })),
                                            React.createElement("input", { type: "tel", inputMode: "tel", autoComplete: "tel", value: this.state.userContact, onChange: function (e) { return _this.handleInputChange('userContact', e.target.value); }, className: "talkbot-form-input", placeholder: "+1 (555) 123-4567", disabled: isLoading })),
                                        this.state.formErrors.contact && (React.createElement("p", { className: "talkbot-form-error" }, this.state.formErrors.contact))),
                                    React.createElement("div", { className: "talkbot-form-group" },
                                        React.createElement("label", { className: "talkbot-form-label" }, "Conversation Mode"),
                                        React.createElement("div", { className: "talkbot-form-mode-row" },
                                            React.createElement("span", { className: "talkbot-form-field-icon talkbot-form-mode-icon" },
                                                React.createElement(MessageSquare, { size: 18 })),
                                            React.createElement("div", { className: "talkbot-form-mode-text" },
                                                React.createElement("span", { className: "talkbot-form-mode-title" }, this.state.videoMode ? 'Avatar mode' : 'Voice mode'),
                                                React.createElement("span", { className: "talkbot-form-mode-hint" }, "You can change this anytime.")),
                                            React.createElement(VideoAudioSwitch, { isVideoMode: this.state.videoMode, onToggle: this.toggleVideoMode, size: "md" }))),
                                    React.createElement("button", { type: "submit", disabled: isLoading, className: "talkbot-form-submit" }, isLoading ? (React.createElement("span", { className: "talkbot-form-submit-inner" },
                                        React.createElement("span", { className: "talkbot-spinner", style: { width: 16, height: 16, borderWidth: 2 } }),
                                        "Connecting...")) : (React.createElement("span", { className: "talkbot-form-submit-inner" },
                                        React.createElement(Zap, { size: 18, fill: "currentColor" }),
                                        "Connect"))),
                                    React.createElement("div", { className: "talkbot-form-secure" },
                                        React.createElement(ShieldCheck, { size: 14 }),
                                        React.createElement("span", null, "Your information is secure and encrypted."))))))) : this.state.videoMode &&
                        getAvatarConfig(this.props.avatarConfig).render !== 'livekit' ? (
                    // Browser-rendered avatar — canvas driven either by the
                    // in-browser edge SDK or by the GPU renderer gateway.
                    React.createElement(EdgeAvatarMode, { config: this.props.avatarConfig, email: this.state.userEmail, contact: this.state.userContact, domain: this.props.domain || window.location.hostname, mode: "avatar", isCircle: shape === 'circle', windowSize: windowSize, onConnectedChange: function (connected) { return _this.setState({ avatarConnected: connected }); }, onEnd: function () { return _this.setState({ showForm: true, error: null, avatarConnected: false }); } })) : connectionDetails ? (
                    // LiveKit Room
                    React.createElement(LiveKitRoom, { serverUrl: connectionDetails.serverUrl, token: connectionDetails.participantToken, connect: true, 
                        // The mic is published by SimpleAvatarInner once the agent has
                        // finished its welcome message, so it cannot talk over itself.
                        audio: false, video: false, style: { width: '100%', height: '100%' } },
                        React.createElement(SimpleAvatarInner, { ref: this.liveKitRef, isCircle: shape === 'circle', windowSize: windowSize, isVoiceMode: !this.state.videoMode, isInputExpanded: this.state.isInputExpanded }))) : isLoading ? (React.createElement("div", { className: "talkbot-center", style: shape === 'circle' ? { borderRadius: '50%' } : undefined },
                        React.createElement("div", { style: { textAlign: 'center', color: 'var(--tb-text)' } },
                            React.createElement("div", { className: "talkbot-spinner", style: { margin: '0 auto 16px' } }),
                            React.createElement("p", { style: { fontSize: 13, opacity: 0.9 } }, "Loading connection details...")))) : (React.createElement("div", { className: "talkbot-center", style: shape === 'circle' ? { borderRadius: '50%' } : undefined },
                        React.createElement("div", { style: { textAlign: 'center', color: 'var(--tb-text)' } },
                            React.createElement("div", { style: { fontSize: 36, marginBottom: 12 } }, "\u274C"),
                            React.createElement("p", { style: { fontSize: 13 } }, "Failed to connect")))))),
                shape === 'box' && connectionDetails && !this.state.showForm && (React.createElement(React.Fragment, null, !this.state.isInputExpanded ? (React.createElement("div", { style: { position: 'absolute', bottom: 8, left: 0, right: 0, display: 'flex', justifyContent: 'center', zIndex: 51 } },
                    React.createElement(Tooltip, { content: "Type a message" },
                        React.createElement("button", { onClick: this.toggleInputExpand, className: "talkbot-expand-btn", "aria-label": "Toggle input area" },
                            React.createElement(ChevronUp, { style: { width: 18, height: 18 } }))))) : (React.createElement(motion.div, { style: { position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 51 }, initial: { height: 0, opacity: 0 }, animate: { height: 'auto', opacity: 1 }, exit: { height: 0, opacity: 0 }, transition: { duration: 0.25, ease: 'easeOut' } },
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'center', position: 'relative', top: -16 } },
                        React.createElement("button", { onClick: this.toggleInputExpand, className: "talkbot-expand-btn", "aria-label": "Close input" },
                            React.createElement(ChevronDown, { style: { width: 16, height: 16 } }))),
                    React.createElement("div", { className: "talkbot-input-area" },
                        React.createElement("input", { placeholder: "Type a message...", value: this.state.message, onChange: function (e) { return _this.setState({ message: e.target.value }); }, onKeyDown: function (e) { return _this.handleKeyPress(e); }, className: "talkbot-input-field", autoComplete: "off" }),
                        React.createElement(Tooltip, { content: "Send" },
                            React.createElement("button", { onClick: this.sendMessage, className: "talkbot-send-btn", "aria-label": "Send message" },
                                React.createElement(Send, { style: { width: 16, height: 16 } })))))))),
                shape === 'circle' && (React.createElement("div", { style: { position: 'absolute', top: 4, left: '50%', transform: 'translateX(-50%)', zIndex: 51 } },
                    React.createElement("div", { className: "talkbot-circle-controls", style: { display: 'flex', gap: 2 } },
                        React.createElement("div", { className: "drag-handle talkbot-circle-btn", style: { padding: getDeviceType() === 'mobile' ? 8 : 6, cursor: 'move' } },
                            React.createElement(Move, { size: getDeviceType() === 'mobile' ? 16 : 14 })),
                        React.createElement("button", { onClick: this.toggleShape, className: "talkbot-circle-btn", style: { padding: getDeviceType() === 'mobile' ? 8 : 6 }, title: "Expand to box" },
                            React.createElement(Square, { size: getDeviceType() === 'mobile' ? 16 : 14 })),
                        React.createElement("button", { onClick: this.toggleSizeOption, className: "talkbot-circle-btn", style: { padding: getDeviceType() === 'mobile' ? 8 : 6 }, title: "Change Size" }, this.getSizeIcon())))))));
    };
    return SimpleAvatarWidget;
}(Component));
export default SimpleAvatarWidget;
